strictInvokeAction = (object, actionName) ->
  Ember.assert 'invoke action must be passed a string as actionName, got ' + actionName, typeof actionName == 'string'
  action = Ember.get(object, actionName)
  _len = arguments.length
  args = Array(if _len > 2 then _len - 2 else 0)
  _key = 2
  while _key < _len
    args[_key - 2] = arguments[_key]
    _key++
  if typeof action == 'string'
    object.sendAction.apply object, [ actionName ].concat(args)
  else if typeof action == 'function'
    return action.apply(undefined, args)
  else
    Ember.assert 'No invokable action ' + actionName + ' was found', false
  return

invokeAction = ->
  try
    return strictInvokeAction.apply(undefined, arguments)
  catch e
    if !e.message.match(/^Assertion Failed: No invokable action .+ was found$/)
      Rollbar.error("That certain place at invoke-action.coffee", e) if window.Rollbar
      throw e
  return

module.exports = Ember.Mixin.create
  invokeAction: ->
    actionName = arguments[0]
    args = Array::slice.call(arguments, 1)
    invokeAction this, actionName, args
  strictInvokeAction: ->
    actionName = arguments[0]
    args = Array::slice.call(arguments, 1)
    strictInvokeAction this, actionName, args

